module.exports = __webpack_public_path__ + "img/swimming.df14231c.svg";